import { Chip } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const MaturedChip = styled(Chip) `
  && {
    padding: 0.3rem;
    margin-left: 0.75rem;
    text-transform: ${({ texttransform }) => texttransform};
    letter-spacing: 1px;
    font-weight: ${({ variant }) => (variant === 'outlined' ? 400 : 500)};
    font-size: 13px;
    color: ${({ variant }) => variant === 'outlined' ? theme.palette.secondary.main : '#ffffff'};
  }
`;
